/* variant-display-by-country.js  — robust + country-aware size display
   1) Sanitizes messy inputs (spaces/colons/slashes/parentheses)
   2) Shows ONE region per shopper (US, UK/AU, EU)
   3) Converts EU if missing (women's mapping: UK = US+4, EU = US+32)
   Display-only: leaves <option value> intact.
*/
(function () {
  var html = document.documentElement;
  var lang = (html.getAttribute('data-locale') || html.getAttribute('lang') || 'en').toLowerCase();
  var country = (html.getAttribute('data-country') || '').toUpperCase();
  var currency = (html.getAttribute('data-currency') || '').toUpperCase();

  // ---------- REGION PREFERENCES ----------
  // Prefer country; fall back to currency; default to US (ROW).
  var regionByCountry = {
    US:'US', CA:'US', MX:'US',
    GB:'UK_AU', IE:'UK_AU', AU:'UK_AU', NZ:'UK_AU',
    AT:'EU', BE:'EU', BG:'EU', HR:'EU', CY:'EU', CZ:'EU', DK:'EU', EE:'EU', FI:'EU',
    FR:'EU', DE:'EU', GR:'EU', HU:'EU', IT:'EU', LV:'EU', LT:'EU', LU:'EU',
    MT:'EU', NL:'EU', PL:'EU', PT:'EU', RO:'EU', SK:'EU', SI:'EU', ES:'EU', SE:'EU',
    AE:'US', SA:'US', KW:'US', QA:'US', BH:'US', OM:'US', EG:'EU', JO:'US', LB:'US', MA:'EU', TN:'EU', DZ:'EU',
    PK:'US', IN:'US', CN:'US', JP:'US', SG:'US', MY:'US', ID:'US', PH:'US'
  };
  var regionByCurrency = {
    USD:'US', CAD:'US', MXN:'US',
    GBP:'UK_AU', AUD:'UK_AU', NZD:'UK_AU',
    EUR:'EU',
    SAR:'US', AED:'US', KWD:'US', QAR:'US', BHD:'US', OMR:'US',
    EGP:'EU', MAD:'EU', DZD:'EU', TND:'EU'
  };
  var defaultRegion = 'US';
  var TARGET = regionByCountry[country] || regionByCurrency[currency] || defaultRegion;

  // ---------- LABELS ----------
  function regionLabel(key) {
    if (lang.startsWith('ar')) {
      return key === 'US' ? 'أمريكي'
        : key === 'UK_AU' ? 'بريطاني/أسترالي'
        : key === 'EU' ? 'أوروبي'
        : key;
    }
    return key === 'UK_AU' ? 'UK/AU' : key;
  }

  // ---------- SANITIZE / PARSE ----------
  // Makes the source variant text tolerant to missing punctuation/spaces/parentheses.
  function sanitizeSource(text) {
    if (!text) return '';
    var s = String(text);

    // Collapse whitespace, unify parentheses to a single " (... )" block if present anywhere
    s = s.replace(/\s+/g, ' ').trim();

    // Ensure there's a space after base size (XS..3XL) and an opening parenthesis for details
    // Accept cases with no parenthesis at all: we'll just parse flat tokens.
    // Also tolerate misordered pieces; we only care about detecting tokens anywhere.
    return s;
  }

  // Extract base (XS..3XL) and regions with tolerant regex
  function parseVariantText(raw) {
    var t = sanitizeSource(raw);

    // Base size
    var baseMatch = t.match(/^\s*(XS|S|M|L|XL|2XL|3XL)\b/i);
    var base = baseMatch ? baseMatch[1].toUpperCase() : '';

    // Helper to get a [min,max] from patterns like "US: 6-8", "US 6/8", "US 6 8", "US:6–8"
    function grabRange(label) {
      var re = new RegExp(label + '\\s*:?' +                   // "US" or "UK/AU" with optional colon
                          '\\s*(\\d{1,2})' +                   // first number
                          '\\s*(?:[-/–\\s]+)?\\s*' +           // optional separator(s)
                          '(\\d{1,2})?', 'i');                 // optional second number
      var m = t.match(re);
      if (!m) return null;
      var a = parseInt(m[1], 10);
      var b = m[2] ? parseInt(m[2], 10) : a;                   // if single number, make it a range a–a
      if (isNaN(a)) return null;
      if (isNaN(b)) b = a;
      // Normalize order if someone typed 10–8
      if (b < a) { var tmp = a; a = b; b = tmp; }
      return [a, b];
    }

    // Try combined UK/AU first; optionally capture separate UK or AU if needed
    var us = grabRange('US|U\\.S\\.');
    var ukau = grabRange('UK\\/AU');
    var uk = grabRange('\\bUK\\b');
    var au = grabRange('\\bAU\\b');
    if (!ukau && (uk || au)) {
      // If only UK or only AU exists, treat as UK/AU for display purposes
      ukau = uk || au;
    }
    // EU often even numbers; tolerate odd if given
    var eu = (function(){
      // Accept "EU: 38-40", "EU 38 40", "EU:38–40"
      var re = /\bEU\s*:?\s*(\d{2})\s*(?:[-/–\s]+)?\s*(\d{2})?/i;
      var m = t.match(re);
      if (!m) return null;
      var a = parseInt(m[1],10);
      var b = m[2] ? parseInt(m[2],10) : a;
      if (b < a) { var tmp=a; a=b; b=tmp; }
      return [a,b];
    })();

    return { base: base, regions: { US: us, UK_AU: ukau, EU: eu } };
  }

  // ---------- CONVERSIONS (women’s dresses/tops) ----------
  // Industry-standard approximations:
  //   UK = US + 4
  //   EU = US + 32
  // (These are typical; brands may vary by 1 size.)
  function usToUkAu(n){ return n + 4; }
  function usToEu(n){
    var val = n + 32;
    // EU apparel usually uses even numbers; bump odd up to next even
    return val % 2 ? val + 1 : val;
  }
  function ukAuToUs(n){ return n - 4; }

  // Ensure the wanted region exists; otherwise synthesize from what we have
  function ensureRegion(parsed, wanted) {
    var r = parsed.regions;
    if (r[wanted]) return r[wanted];

    // Prefer building from US
    if (r.US) {
      var a = r.US[0], b = r.US[1];
      if (wanted === 'UK_AU') return [usToUkAu(a), usToUkAu(b)];
      if (wanted === 'EU')    return [usToEu(a),   usToEu(b)];
    }
    // Else build from UK/AU
    if (r.UK_AU) {
      var a2 = r.UK_AU[0], b2 = r.UK_AU[1];
      var usA = [ukAuToUs(a2), ukAuToUs(b2)];
      if (wanted === 'US') return usA;
      if (wanted === 'EU') return [usToEu(usA[0]), usToEu(usA[1])];
    }
    // Else fall back to whatever we have
    return r.US || r.UK_AU || r.EU || null;
  }

  function fmtRange(pair){ return pair ? (pair[0] + '–' + pair[1]) : ''; }

  function buildDisplay(originalText) {
    if (!originalText) return originalText;
    var parsed = parseVariantText(originalText);
    if (!parsed || !parsed.base) return originalText;

    var chosen = ensureRegion(parsed, TARGET);
    if (!chosen) return originalText;

    // Final clean format: "M (US: 6–8)" or Arabic equivalents
    var label = regionLabel(TARGET);
    return parsed.base + ' (' + label + ': ' + fmtRange(chosen) + ')';
  }

  function localizePicker(root) {
    if (!root || !(root.querySelectorAll)) return;

    // <select> options
    root.querySelectorAll('select option').forEach(function (opt) {
      var t = opt.textContent;
      var disp = buildDisplay(t);
      if (disp && disp !== t) opt.textContent = disp;
    });

    // Radio/swatch labels
    root.querySelectorAll('label, .swatch__item-label, .product-form__input label').forEach(function (lab) {
      if (lab.childElementCount === 0) {
        var t = lab.textContent;
        if (lang.startsWith('ar') && /\bsize\b/i.test(t)) { lab.textContent = 'المقاس'; return; }
        var disp = buildDisplay(t);
        if (disp && disp !== t) lab.textContent = disp;
      }
    });

    // Placeholder "Select Size" in Arabic
    if (lang.startsWith('ar')) {
      root.querySelectorAll('select').forEach(function (sel) {
        if (sel.options && sel.options.length) {
          var first = sel.options[0];
          if (first && /\bselect\b/i.test(first.textContent) && /\bsize\b/i.test(first.textContent)) {
            first.textContent = 'اختر المقاس';
          }
        }
      });
    }
  }

  // Initial run + observe hydration
  localizePicker(document);
  var obs = new MutationObserver(function (muts) {
    for (var i=0;i<muts.length;i++){
      if (muts[i].addedNodes && muts[i].addedNodes.length) { localizePicker(document); break; }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Debug helper
  window.__sizeRegionDebug = { country: country, currency: currency, target: TARGET };
})();
